<div class="manage-vendors-container">
    <h2>Manage Vendors</h2>

    <!-- Vendors Table -->
    <div *ngIf="vendors.length > 0" class="vendors-table">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Vendor ID</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>ERP Vendor ID</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vendor of vendors">
                    <td>{{ vendor.vendorID }}</td>
                    <td>{{ vendor.email }}</td>
                    <td>{{ vendor.mobile }}</td>
                    <td>{{ vendor.ERPVendorID }}</td>
                    <td>{{ vendor.status }}</td>
                    <td>
                        <button
                            class="btn btn-secondary me-2"
                            [disabled]="vendor.createdBy !== 'ERP'"
                            (click)="inviteVendor(vendor)">
                            Invite
                        </button>
                        <button class="btn btn-primary me-2" (click)="migrateVendor(vendor)">
                            Migrate
                        </button>
                        <button class="btn btn-danger" (click)="deleteVendor(vendor)">
                            Delete
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="vendors.length === 0" class="empty-state">
